import styled from "@emotion/styled/macro";
import { forwardRef } from "react";
import { useLocation } from "react-router-dom";
import { maxWidth } from "../../helpers/styleConstants";

type IFrameProps = {
  basePath: string;
  src: string;
  title: string;
  isAuth?: boolean;
};

const IFrame = forwardRef<HTMLIFrameElement, Omit<IFrameProps, "ref">>(
  ({ basePath, src, title, isAuth = false }, ref) => {
    // @ts-ignore window.ReactNativeWebView is only available in the mobile app
    const isInOneMobileApp = window.ReactNativeWebView;

    const { pathname } = useLocation();
    const isCreateLeadPage = pathname === "/customers/create";

    return (
      <IFrameContainer
        key={basePath}
        ref={ref}
        src={src}
        title={title}
        allow="geolocation; fullscreen; clipboard-write;"
        isAuth={isAuth}
        isInOneMobileApp={isInOneMobileApp}
        isCreateLeadPage={isCreateLeadPage}
      />
    );
  }
);

const IFrameContainer = styled.iframe<{
  isAuth: boolean;
  isInOneMobileApp: boolean;
  isCreateLeadPage: boolean;
}>`
  width: 100%;
  height: ${({ isAuth, isInOneMobileApp, isCreateLeadPage }) =>
    isAuth || isInOneMobileApp || isCreateLeadPage
      ? "100vh" // SideNav is not visible on auth page
      : "calc(100vh - 75px)"}; // Deduct height of SideNav, which is shown at bottom of the page on mobile
  border: 0px;
  flex-grow: 1;
  display: block;

  @media (min-width: ${maxWidth + 1}px) {
    height: 100vh;
  }
`;

export { IFrame };
